import React from 'react'
import FileUploader from 'react-firebase-file-uploader';
import classnames from 'classnames';
import SlideLayoutPreview from "./SlideLayoutPreview";
import { FieldArray, Field } from 'formik';
import StyledField from "../../components/StyledField/StyledField";
import FileUpload from "../../components/FileUpload/FileUpload";
import Icon from "../../components/Icon/Icon";
import defaultColumn from './defaultColumn';
import styled from 'styled-components';
import LabelHint from '../../components/LabelHint';

const Hint = styled.div`
  color: #333333;
  font-size: 15px;
  margin-top: 0;
`;

const Subtitle = styled.h3`
  margin: 0 0 4px 0;
`;

class LayoutForm extends React.Component {
  state = {
    selectedColumn: 0
  };

  handleSelectColumn = (index) => {
    this.setState({ selectedColumn: index })
  };

  render() {
    const { values, selectedSlide } = this.props;
    const { selectedColumn } = this.state;
    const columns = values.slides[selectedSlide].layout.columns;

    return (<FieldArray name={`slides.${this.props.selectedSlide}.layout.columns`} render=
        { arrayHelpers => {
          return (
              <div>
                <ul className="tabs">
                  { columns.length > 0 && columns.map((column, index) => {
                    const classes = {'active': selectedColumn === index};
                    return (
                        <li className={classnames(classes)} onClick={() => this.handleSelectColumn(index)}
                            key={index}>{column.title}</li>
                    )
                  })
                  }
                  <li className="">
                    <span className="plus-button" onClick={(e) => { arrayHelpers.insert(columns.length + 1, defaultColumn)} }>
                      <Icon name="add" inline label="Add"/>
                      Photo
                    </span>
                  </li>
                </ul>



                {values.slides[selectedSlide].layout.columns.length > 0 && values.slides[selectedSlide].layout.columns.map((column, index) => {
                  const classes = ['tab-content', 'margin--bottom', {'is-enabled': index === selectedColumn}];

                  return (
                      <div key={index} className={classnames(classes)}>
                        <div className="grid">
                          {  values.slides[selectedSlide].layout.columns[selectedColumn]
                              && values.slides[selectedSlide].layout.columns[selectedColumn].photo
                              && values.slides[selectedSlide].layout.columns[selectedColumn].photo.url ? <div className="grid-item">
                            <div className="field-group">
                              <LabelHint hint="Used for admin only (not shown on site)">Title</LabelHint>
                              <Field placeholder="Title" name={`slides.${ selectedSlide }.layout.columns.${ index }.title`} />
                            </div>
                            <div className="margin--bottom">
                              <Subtitle>Image placement</Subtitle>
                              <Hint>Set the image to span from column start to column end, and row start to row end.</Hint>
                              <div className="field-group--inline">
                                <Field component={ StyledField } hint="The starting vertical grid line for the photo (e.g., 1)" inline small label="Start col." name={`slides.${ selectedSlide }.layout.columns.${ index }.columnStart`} />
                                <Field component={ StyledField } hint={"The ending vertival grid line for the photo (e.g, 6)"}inline small label="to col." name={`slides.${ selectedSlide }.layout.columns.${ index }.columnEnd`} />
                              </div>
                              <div className="field-group field-group--inline">
                                <Field component={ StyledField } hint="The starting horizontal grid line for the photo (e.g., 1)" inline small label="Start row" name={`slides.${ selectedSlide }.layout.columns.${ index }.rowStart`} />
                                <Field component={ StyledField } hint="The ending vertical grid line for the photo (e.g., 6)" inline small label="to row" name={`slides.${ selectedSlide }.layout.columns.${ index }.rowEnd`} />
                              </div>
                            </div>
                            <div className="field-group--inline margin--top">
                              <LabelHint hint="Contain will scale the image proportionally to fit within the grid lines. Cover will proportionally fit the image fully within the gridlines, but some data may be cropped.">Image fit</LabelHint>
                              <Field component="select" name={`slides.${ selectedSlide }.layout.columns.${ index }.imageAppearance`}>
                                <option value="contain">Contain</option>
                                <option value="cover">Cover</option>
                              </Field>
                            </div>
                            <div className="field-group--inline">
                              <LabelHint hint="Will weight the image to the position selected. Only used when Cover is selected as Image Fit.">Image Position</LabelHint>

                              <Field component="select" name={`slides.${ selectedSlide }.layout.columns.${ index }.imagePosition`}>
                                <option value="top left">Top Left</option>
                                <option value="top">Top</option>
                                <option value="top right">Top Right</option>
                                <option value="left">Left</option>
                                <option value="center">Center</option>
                                <option value="right">Right</option>
                                <option value="bottom left">Bottom Left</option>
                                <option value="bottom">Bottom</option>
                                <option value="bottom right">Bottom Right</option>
                              </Field>
                            </div>
                            <div className="margin--bottom" style={ { display: 'none'} }>
                              <Subtitle>Image placement</Subtitle>
                              <div className="field-group--inline">
                                <Field component={ StyledField } inline small label="Height" name={`slides.${ selectedSlide }.layout.columns.${ index }.height`} />
                                <Field component={ StyledField } inline small label="Width" name={`slides.${ selectedSlide }.layout.columns.${ index }.width`} />
                              </div>
                              <div className="field-group--inline">
                                <Field component={ StyledField } inline small label="H-Align" name={`slides.${ selectedSlide }.layout.columns.${ index }.hAlign`} />
                                <Field component={ StyledField } inline small label="V-Align" name={`slides.${ selectedSlide }.layout.columns.${ index }.vAlign`} />
                              </div>
                            </div>
                          </div> : <div className="grid-item">Slides are made up of one or more grid columns. To create your first grid column, select a photo.</div> }
                          <div className="grid-item">

                            { values.slides[selectedSlide].layout.columns[selectedColumn]
                                && values.slides[selectedSlide].layout.columns[selectedColumn].photo
                                && !values.slides[selectedSlide].layout.columns[selectedColumn].photo.url ?
                            <FileUpload firebase={ this.props.firebase }
                                        directory={ this.props.directory }
                                        name={`slides.${ selectedSlide }.layout.columns.${ index }.photo.url`}
                                        label="Select a photo"
                                        hint="File should be 800x800 pixels or larger."
                            /> : <div className="margin--top">
                                  <SlideLayoutPreview selectedColumn={selectedColumn}
                                                      layout={values.slides[selectedSlide].layout}
                                                      columns={values.slides[selectedSlide].layout.columns}
                                                      device={ this.props.device }
                                  />
                                </div>
                            }
                            { values.slides[selectedSlide] &&
                              values.slides[selectedSlide].layout &&
                              values.slides[selectedSlide].layout.columns[selectedColumn] &&
                              values.slides[selectedSlide].layout.columns[selectedColumn].photo &&
                              values.slides[selectedSlide].layout.columns[selectedColumn].photo.url &&
                            <div className="field-group--inline">
                              <span style={{cursor: 'pointer'}} onClick={ () => { this.props.setFieldValue(`slides.${selectedSlide}.layout.columns.${index}.photo.url`, '') } }>
                                <Icon name="trash" inline label="Remove"/> Remove photo</span>
                            </div>}
                          </div>


                        </div>
                      </div>)
                })}
              </div>);

        }} />)
  }
}

export default LayoutForm;



// WEBPACK FOOTER //
// ./src/containers/add/LayoutForm.js